
import _ from 'lodash';
import Deliver from './deliver.vue';
import DeleteButton from '../components/delete-button.vue';
import BatchUploader from './batch-uploader.vue';
import { removeFileExtension } from '@/common/file';

export default {
  components: {
    Deliver: Deliver,
    DeleteButton: DeleteButton,
    BatchUploader: BatchUploader
  },

  props: {
    deliverGroupList: {
      type: Array,
      required: true
    },

    addDeliver: {
      type: Function,
      required: true
    },

    deleteDeliver: {
      type: Function,
      required: true
    },

    schemeValue: {
      type: Object,
      default: function _default() {}
    },

    updateDeliver: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      dialog: {
        visible: false,
        title: '批量上传附件'
      },
      copyDeliverTag: '',
      copySceneNum: '',
      fileList: [],
      currentGroupIndex: '',
      creationTags: []
    };
  },


  watch: {
    'dialog.visible': function dialogVisible() {
      this.fileList = [];
    }
  },

  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.fileList.map(function (file) {
        return {
          path: _.get(file, 'response.data.file_path') || '',
          url: _.get(file, 'response.data.url') || '',
          file_name: file.name,
          name: removeFileExtension(file.name)
        };
      }).map(function (file) {
        _this.addDeliver({
          groupIndex: _this.currentGroupIndex,
          deliver: file
        });
        // 每次批量上传时，将没有填任何东西的交付物表单删除
        _this.deliverGroupList[_this.currentGroupIndex].map(function (deliver, index) {
          if (!deliver.path && !deliver.name && deliver.tag_ids.length === 0) {
            _this.deleteDeliver({
              deliverIndex: index,
              groupIndex: _this.currentGroupIndex
            });
          }
        });
      });

      this.closeDialog();
    },
    handleCopyDeliverTag: function handleCopyDeliverTag(deliver) {
      console.log(deliver.material_tag_ids);
      console.log(deliver.scene_num);
      if (deliver.material_tag_ids) {
        this.copyDeliverTag = deliver.material_tag_ids;
        this.copySceneNum = deliver.scene_num;
        this.$message({
          type: 'success',
          message: '复制成功。'
        });
      } else {
        this.$message('请选择特征标签后复制。');
      }
    },


    /**
     * 更新交付表单组列表项
     * @param {Object} option
     * @param {number} option.deliverIndex
     * @param {number} option.groupIndex
     * @param {Object} option.deliver
     */
    handleUpdateDeliver: function handleUpdateDeliver(_ref) {
      var deliverIndex = _ref.deliverIndex,
          groupIndex = _ref.groupIndex,
          deliver = _ref.deliver;

      this.updateDeliver({ deliverIndex: deliverIndex, groupIndex: groupIndex, deliver: deliver });
    },


    /**
     * @param {number} groupIndex
     */
    openDialog: function openDialog(groupIndex) {
      this.currentGroupIndex = groupIndex;
      this.dialog.visible = true;
    },
    closeDialog: function closeDialog() {
      this.dialog.visible = false;
    },


    /**
     * @param {{name: string, url: string}} fileList
     */
    setFileList: function setFileList(fileList) {
      this.fileList = fileList;
    }
  }
};